import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import { analyticsMiddleware } from 'vue-analytics'

import getters from './getters'
import mutations from './mutations'
import actions from './actions'
import { AlertsModule } from './modules/alerts'
import { TrainingToolModule } from './modules/trainingTool'
import { EventsModule } from './modules/events'
import { FaceMaskAlertsModule } from './modules/faceMaskAlerts'
import { ViewerModule } from './modules/viewer'
import { RefreshModule } from './modules/refreshState'
import { ERModule } from './modules/elopementRisk'
import { FeaturesModule } from './modules/features'
import { entitlementsModule } from './modules/entitlements'
import { OnboardModule } from './modules/onboard'
import { CredentialMismatch } from './modules/credentialMismatch'
import { facesModule } from './modules/faces'
import { ViewerToolsModule } from './modules/viewerTools'
import { DnaModule } from './modules/dna'
import { DnaConfigurationModule } from './modules/dnaConfiguration'
import { RealtimeCredentials } from './modules/realtimeCredentials'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    authToken: '',
    displayName: '',
    email: '',
    staff: false,
    data: {
      domains: {
        all: [],
        uuids: [],
        current: {
          description: undefined,
          uuid: undefined,
        },
        by: {
          uuid: {},
          cameraUUID: {},
        },
      },
      cameras: {
        all: [],
        uuids: [],
        current: {
          description: undefined,
          uuid: undefined,
        },
        by: {
          uuid: {},
          domainUUID: {},
        },
      },
    },
    faces: [],
    demoNames: {},
    history: [],
  },
  modules: {
    alerts: AlertsModule,
    events: EventsModule,
    faceMaskAlerts: FaceMaskAlertsModule,
    viewer: ViewerModule,
    elopementRisks: ERModule,
    trainingTool: TrainingToolModule,
    features: FeaturesModule,
    credentialMismatch: CredentialMismatch,
    entitlements: entitlementsModule,
    onboard: OnboardModule,
    refresh: RefreshModule,
    facesModule, // Note: +Module to prevent naming conflict. Should be renamed to 'faces' once store is refactored.
    viewerTools: ViewerToolsModule,
    dna: DnaModule,
    dnaConfiguration: DnaConfigurationModule,
    realtimeCredentials: RealtimeCredentials,
  },
  getters,
  mutations,
  actions,
  strict: process.env.NODE_ENV !== 'production',
  plugins: [
    createPersistedState({
      paths: [
        'authToken',
        'displayName',
        'email',
        'trainingTool.filters',
        'features.flags',
        'events.filters',
        'events.queryParameters',
        'data.domains.current',
        'data.cameras.current',
        'entitlements.entitlementsByDomain',
      ],
    }),
    analyticsMiddleware,
  ],
})
